<template>
  <div :class="$style['sample-list']">
    <h1>北京市科学技术研究院分析测试研究所</h1>
    <h2>(北京市理化分析测试中心)</h2>
    <h1>委托检验检测协议书附页</h1>
    <table cellspacing="0" border="1">
      <tr>
        <th class="sample-name">样品名称</th>
        <th class="sample-name">样品编号</th>
        <th class="sample-name">客户标识</th>
        <th>规格/型号</th>
        <th>数量</th>
        <th>颜色、状态、包装</th>
        <th>存放条件</th>
        <th class="exam-item">检验检测项目</th>
        <th class="exam-item">检验检测依据</th>
        <th>备注</th>
      </tr>
      <tr v-for="(item, index) in data" :key="index">
        <td>{{ item.sampleName }}</td>
        <td>{{item.sampleCode}}</td>
        <td>{{ item.customerCode||'--' }}</td>
        <td>
          {{ item.specificationModel }}
        </td>
        <td>{{ item.number + + '' + (item.numberUnit ? item.numberUnit : '批')  }}</td>
        <td>
          {{ item.color && item.color + "/" }}{{ item.shape && item.shape + "/"
          }}{{ item.pack }}
        </td>
        <td>{{ item.storage }}</td>
        <td>{{ item.examinationItem }}</td>
        <td>
          <div v-for="(etem, index) in item.examinationItemBasis" :key="index" class="examination-item-basis">
            {{ etem }}
          </div>
        </td>
        <td>{{ item.remark||'--' }}</td>
      </tr>
    </table>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: [Array, Object],
      default: function () {
        return [];
      },
    },
    loaded: Boolean,
    loadErr: Boolean,
  },
  components: {
	},
  watch: {
    loaded(val) {
      if (val) {
        this.checkLoad();
      }
    },
    loadErr(val) {
      if (val) {
        this.checkLoad();
      }
    },
  },
  methods: {
    checkLoad() {
      if (this.loaded) {
        this.loadedPage = true;
        confirm("加载完成");
      }
      if (this.loadedErr) {
        this.loadedPage = true;
        confirm("加载失败");
      }
    },
	},
	created(){
	}
};
</script>
<style module lang="less">
.sample-list {
  padding: 15px;
  font-size: 13px;
  padding-top: 30px;
  :global {
		.examination-item-basis{
		}
    .sample-name {
      min-width: 4em;
    }
    .exam-item {
      max-width: 4em;
    }
  }
  table {
    width: 100%;
  }
  h1,
  h2 {
    margin-block-start: 0.3em;
    margin-block-end: 0.3em;
  }
  tr {
  }
  td,
  th {
    padding: 5px 10px;
  }
  td {
    height: 25px;
			line-height: 15px;
  }
}
</style>
